import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var GraphQLNoResultsError = /*#__PURE__*/function (_Error) {
  function GraphQLNoResultsError(graphQLErrors) {
    var _this;
    _classCallCheck(this, GraphQLNoResultsError);
    _this = _callSuper(this, GraphQLNoResultsError);
    _this.name = 'GraphQLNoResultsError';
    _this.errors = graphQLErrors;
    _this.message = 'GraphQL returned errors & no results';
    _this.errorMessages = graphQLErrors.map(function (error) {
      return error.message;
    });
    return _this;
  }
  _inherits(GraphQLNoResultsError, _Error);
  return _createClass(GraphQLNoResultsError);
}( /*#__PURE__*/_wrapNativeSuper(Error));